import { FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { Adapter, IFormSelfAssessSetting, Pattern, SelfAssessService, SelfAssessSettingRequestDto } from '../../modules/core'
import { catchErrorMsg } from '../../modules/core/helpers/Helper'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import {  FormInputNumber } from 'app/components'
import { PageTitle } from '_metronic/layout/core'

type Props = {

}

export const SelfSettingEditPage: FC<Props> = () => {

    let initValue: IFormSelfAssessSetting = {
        assessTypeId: 1,
        category: '',
        title: '',
        point: 0
    }
    const formSchema = Yup.object().shape({
        title: Yup.string().required('require'),
        category: Yup.string().required('require'),
        point: Yup.number().moreThan(0, "more than zero").required('require'),

    })


    const [loading, setLoading] = useState(true)
    const [data, setData] = useState<IFormSelfAssessSetting>(initValue)

    const { id } = useParams()
    const navigate = useNavigate()
    useEffect(() => {
        const init = () => {
            if (id && id !== 'new') {

                SelfAssessService.GetSelfAssesssSettingById(Number(id)).then((result) => {
                    const res = result.data.result
                    if (res) {
                        const frmDto = Adapter.FormSelfAssessSetting(res);
                        setData(frmDto)
                    }
                })
            }
            setLoading(false)
        }
        init()
    }, [id])

    const onSubmit = async (values: IFormSelfAssessSetting) => {
        setLoading(true)
        const updatedData = Adapter.mapSelfAssessSetting(values)
        if (id) {
            Update(Number(id), updatedData)
        }
      
    }



    const Update = (id: number, updatedData: SelfAssessSettingRequestDto) => {
        SelfAssessService.UpdateSelfAssesss(id, updatedData).then(() => {
            toast.success('Update Success.')
            navigate('/setting/self')
        }).catch((res) => {
            toast.error(catchErrorMsg(res));
            setLoading(false);
        })
        
    }

    const CellStyle: React.FC<{ lable: string, children?: React.ReactNode, labelCls?: string, inputCls?: string, txtEndCls?: string, textEnd?: string }> = (props) => {
        const labelCls = props.labelCls ?? 'col-lg-4 fw-bold'
        const inputCls = props.inputCls ?? 'col-lg-4'
        return (
            <div className='row mb-7'>
                <label className={labelCls}>{props.lable}</label>
                <div className={inputCls}>
                    <span className='fw-bolder fs-6 text-dark'>{props.children}</span>

                </div>
                {props.textEnd && <div className={props.txtEndCls}>
                    <span > {props.textEnd}</span>
                </div>}
            </div>
        )
    }


    return (
        <>
            <PageTitle
                breadcrumbs={[
                    {
                        title: 'Setting',
                        path: 'setting',
                        isSeparator: false,
                        isActive: false,
                    }
                ]}
            >
                SelfAssess
            </PageTitle>
            <div className='card mb-5 mb-xl-10'>
                <div className='card-header cursor-pointer'>
                    <div className='card-title m-0 '>
                        <h3 className='fw-bolder py-2'>SelfAssess</h3>

                    </div>
                </div>
                <Formik
                    enableReinitialize
                    initialValues={data}
                    validationSchema={formSchema}
                    onSubmit={onSubmit}                     
                >
                    {({ values, handleSubmit, setFieldValue, errors, touched }) => (
                        <Form>
                            <>
                                {/* begin::Scroll */}
                                <div className='card-body p-9'>
                                    <CellStyle lable='ชื่อ'>
                                        <Field
                                            name='title'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.title && touched.title ? ' is-invalid' : '')
                                            }
                                        />
                                        <ErrorMessage name={`title`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='ประเภท'>
                                        <label> {values.category}</label>
                                    </CellStyle>
                                    <CellStyle lable='คะแนน'>
                                        <Field
                                            name='point'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.point && touched.point ? ' is-invalid' : '')
                                            }
                                            maxLength={18}
                                            pattern={Pattern.Number}
                                            component={FormInputNumber}
                                        />
                                        <ErrorMessage name={`point`} component='div' className='text-danger' />
                                    </CellStyle>

                                </div>
                                {/* end::Scroll */}

                                <div className='card-footer d-flex py-6 px-9'>
                                    <button type='submit' className='btn btn-primary pe-5  me-10' disabled={loading}>
                                        {!loading && 'Save Changes'}
                                        {loading && (
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                Please wait...
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        )}
                                    </button>

                                    <button className='btn btn-light' onClick={() => navigate('/setting/self')}> Back</button>
                                </div>
                            </>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    )
}

